import commonMixin from '../mixins/common.js'
import resultMixin from '../mixins/result.js'

export default {
    el: '#app-form',
    
    mixins: [
        commonMixin,
        resultMixin,
    ],

    methods: {
        formChanged: function() {
            this.updateAreaInfoDisp()
            this.loadCount()
        },

        loadCount: async function() {
            let conditions = this.queryByForm(), 
                cls = 'resultNumber_button-invalid',
                btn = document.form.querySelectorAll('button[type="submit"]'),
                cnt = 0

            await this.$store.dispatch('itemCount/getCount', conditions)
            cnt = this.$store.getters['itemCount/count']
            for (let e of btn) {
                if(cnt < 1) {
                    if (!e.classList.contains(cls)) {
                        e.classList.add(cls)
                    }
                    e.disabled = true
                } else {
                    e.classList.remove(cls)
                    e.disabled = false
                }
            }
        },

        checkDisabled: function(event) {
            let btn = document.querySelectorAll(".resultNumber_button-invalid")
            if (btn.length > 0) {
                event.preventDefault()
                event.stopPropagation()
            }
        },

        updateAreaInfoDisp: function() {
            let form = document.querySelectorAll("input[name='area_info[]']:checked"), 
                str = [], 
                elm = document.getElementById('app-area-selected')
            for (let e of form) {
                if (e.checked) {
                    str.push(e.value)
                }
            }
            elm.innerText = str.length > 0 ? str.join(',') : 'エリアを選ぶ'
            document.getElementById('app-resultNumber').style.visibility = 'visible'
        }
    },

    mounted: function() {
        /**
         * フォームの指定から検索結果の件数をstoreにセット
         */
        this.loadCount()
    },

    created: function() {
        /*
         * 保存された検索条件をstoreにセット
         */
        this.restoreSearchConditionHistory()
    }
}
